export function parseFirstLetterProfileFullName (fullName) {
  let arr = fullName.split(' ')
  let firstLetter = arr[0].substring(0, 1).toUpperCase()
  let secondLetter = arr[arr.length - 1].substring(0, 1).toUpperCase()

  return `${firstLetter}${secondLetter}`
}



// WEBPACK FOOTER //
// ./src/utils/parseFirstLetterProfileFullName.js